import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { combineValues } from '@clds/component-theme';
import { typographyMixin } from '@clds/typography';
import { formTheme } from './theme';
const Root = styled.label `
  display: block;
  ${combineValues(formTheme.label.typography, (props) => typographyMixin(props))};
  margin: ${formTheme.label.margin.vertical} 0;
  cursor: pointer;
`;
const Mandatory = styled.span `
  ${combineValues(formTheme.label.mandatoryTypography, (props) => typographyMixin(props))};
`;
export const Label = asStyledComponent((_a) => {
    var { mandatory, children } = _a, rest = __rest(_a, ["mandatory", "children"]);
    return (React.createElement(Root, Object.assign({}, rest),
        children,
        mandatory && React.createElement(Mandatory, null, "\u00A0*")));
});
//# sourceMappingURL=Label.js.map